import { defineMessages } from 'react-intl';

export const messages: {
	blueColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	greenColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	limeColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	magentaColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	neutralColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	orangeColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	purpleColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	redColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	statusInputLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tealColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	yellowColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	neutralColor: {
		id: 'fabric.status.color.grey',
		defaultMessage: 'Gray',
		description: 'Tooltip for the gray color in color palette',
	},
	purpleColor: {
		id: 'fabric.status.color.purple',
		defaultMessage: 'Purple',
		description: 'Tooltip for the purple color in color palette',
	},
	blueColor: {
		id: 'fabric.status.color.blue',
		defaultMessage: 'Blue',
		description: 'Tooltip for the blue color in color palette',
	},
	redColor: {
		id: 'fabric.status.color.red',
		defaultMessage: 'Red',
		description: 'Tooltip for the red color in color palette',
	},
	yellowColor: {
		id: 'fabric.status.color.yellow',
		defaultMessage: 'Yellow',
		description: 'Tooltip for the yellow color in color palette',
	},
	greenColor: {
		id: 'fabric.status.color.green',
		defaultMessage: 'Green',
		description: 'Tooltip for the green color in color palette',
	},
	tealColor: {
		id: 'fabric.status.color.teal',
		defaultMessage: 'Teal',
		description: 'Tooltip for the teal color in color palette',
	},
	limeColor: {
		id: 'fabric.status.color.lime',
		defaultMessage: 'Lime',
		description: 'Tooltip for the lime color in color palette',
	},
	orangeColor: {
		id: 'fabric.status.color.orange',
		defaultMessage: 'Orange',
		description: 'Tooltip for the orange color in color palette',
	},
	magentaColor: {
		id: 'fabric.status.color.magenta',
		defaultMessage: 'Magenta',
		description: 'Tooltip for the magenta color in color palette',
	},
	statusInputLabel: {
		id: 'fabric.status.input.label',
		defaultMessage: 'Set a status',
		description: 'Aria label text for the status input field',
	},
});
